/* eslint-disable*/
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Login, UserRegistration, ForgotPassword, ResetPassword, Main } from '..';

import { PrivateRoute } from '../PrivateRoute';
import './App.less';
import { APIProvider } from '@vis.gl/react-google-maps';
const Authenticated = () => <Main />;

export const App = () => {
  return (
    <APIProvider apiKey={'AIzaSyBmqYJF_Ej9xwD_MRzpWfDSnwW_vHy3pnw'} onLoad={() => console.log('Maps API has loaded.')}>
      <div className="app">
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={UserRegistration} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/forgot-password/:hash/:token" component={ResetPassword} />
          <PrivateRoute component={Authenticated} />
        </Switch>
      </div>
    </APIProvider>
  );
};
